import { Flex, Loading } from '@fe-toolkit/web-components/ssr'

export default function ProfilePageLoader() {
  return (
    <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
      <Loading />
    </Flex>
  )
}
